import pluralize from "pluralize";
import { ASSESSMENT_MODEL } from "@/models/assessment-model";
import { BOOKING_MODEL } from "@/models/booking-model";
import { USER_MODEL } from "@/models/user-model";
import { ORGANISATION_MODEL } from "@/models/organisation-model";

export const APPLICATION_MODEL = "application";

const applicationModel = {
  status: "",
  applicationReference: "",
  rejectionReason: "",
  evaluationStatus: "",
  awr: false,
  reason: "",
  utm_source: "",
  afterDeadlineApplyKey: "",
  meetsRequirements: false,
  bookingId: null,
  assessments: {
    jsonApi: "hasMany",
    type: pluralize(ASSESSMENT_MODEL)
  },
  booking: {
    jsonApi: "hasOne",
    type: pluralize(BOOKING_MODEL)
  },
  createdBy: {
    jsonApi: "hasOne",
    type: pluralize(USER_MODEL)
  },
  user: {
    jsonApi: "hasOne",
    type: pluralize(USER_MODEL)
  },
  organisation: {
    jsonApi: "hasOne",
    type: ORGANISATION_MODEL
  },
  comments: {
    jsonApi: "hasMany",
    type: "comment"
  }
};

export const applicationActions = {
  APPLICATIONS: "applications",
  AVAILABLE_CANDIDATES: "available-candidates",
  WITHDRAW: "withdraw",
  REJECT: "reject",
  APPROVE: "approve",
  SHORTLIST: "shortlist",
  SUBMIT: "submit",
  UNSORTED: "unsorted"
};

export default applicationModel;
